var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.833,
  d: "M11 11.917a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834M11 5.5a.917.917 0 1 0 0-1.833.917.917 0 0 0 0 1.833M11 18.333a.917.917 0 1 0 0-1.833.917.917 0 0 0 0 1.833"
})));
export { SvgMoreIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/moreIcon.svg";